import type { ComputedRef, InjectionKey } from 'vue'

import type { KControlSize } from '../../types'

export interface KFieldsetContext {
    disabled: ComputedRef<boolean>
    nativeDisabled: ComputedRef<boolean>
    required: ComputedRef<boolean>
    size: ComputedRef<KControlSize>
    describedBy: ComputedRef<string | undefined>
}

export const K_FIELDSET_CONTEXT = Symbol('KFieldset') as InjectionKey<KFieldsetContext>
